/* istanbul ignore file */
import React from 'react';
import { Show } from 'framework/show';
import useAssetService from 'domain/finance/assets/useAssetService';
import { useAssetId, useAssetUrl } from 'domain/finance/assets/shared/useAssetRouting';
import ViewAssetPageContent from './ViewAssetPageContent';
import { SensitiveShowElementLayout } from 'framework/sensitiveData';

const AssetViewPage = () => {
  const { getById } = useAssetService();
  const id = useAssetId();
  const { getListUrl } = useAssetUrl();

  return (
    <Show getDataMethod={() => getById(id)}>
      <SensitiveShowElementLayout
        // TODO: Update after updating BE
        loadSensitiveDataMethod={() => Promise.resolve({})}
        sensitiveDataId={id}
        sensitiveDataIdSource="id"
        timerId={getListUrl()}
      >
        <ViewAssetPageContent />
      </SensitiveShowElementLayout>
    </Show>
  );
};

export default AssetViewPage;
